export default __webpack_public_path__ + "static/media/ORIXM.965673fc.png";